import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation bulkUpdatePersonMutation($input: BulkUpdatePersonInput!) {
		bulkUpdatePerson(input: $input) {
			errors
			persons {
				id
				email
				jobTitle
				department {
					id
				}
				firstName
				lastName
				initials
				profiles(first: 10000) {
					edges {
						node {
							id
							name
						}
					}
				}
				permissions
				cost
				phone
				language
				active
				invited
				profilePictureId
				excludeFromCompanyLockedPeriod
				startDate
				endDate
				role {
					id
					name
				}
				holidayCalendar {
					id
				}
				personLabels(first: 10000) {
					edges {
						node {
							label {
								id
							}
						}
					}
				}
				gitlabUser {
					integrationUserId
				}
				gitlabServerUser {
					integrationUserId
				}
				githubUser {
					integrationUserId
				}
				unit4UserObject
				jiraCloudId
				jiraServerId
			}
		}
	}
`;

function getConfigs() {
	return [];
}

function commit(environment, input, onSuccess, onError, uploadables) {
	const changes = [];

	for (const key of Object.keys(input)) {
		if (['ids'].includes(key) || input[key] === undefined) {
			continue;
		}

		changes.push(key);
	}

	tracking.trackEvent('Person bulk Updated', {_Changed: changes});

	return trackAndCommitMutation(
		environment,
		{
			mutation,
			variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
			uploadables,
			configs: getConfigs(),
			onCompleted: onSuccess,
			onError: onError,
		},
		true
	);
}

export default {commit};
